var map = {
	"./GameBoardLayout": 55,
	"./GameBoardLayout.ts": 55,
	"./GameEndPopup": 56,
	"./GameEndPopup.ts": 56,
	"./GameOverLeaderboardPopup": 57,
	"./GameOverLeaderboardPopup.ts": 57,
	"./LeaderboardPopup": 58,
	"./LeaderboardPopup.ts": 58,
	"./ShooterLayout": 54,
	"./ShooterLayout.ts": 54,
	"./TestLayout": 160,
	"./TestLayout.ts": 160,
	"./WaitingScreen": 59,
	"./WaitingScreen.ts": 59
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 331;